<script lang="ts">
    import type { CollapsibleControlManager } from "./CollapsibleControlManager";
    import Control from "./Control.svelte";

    let className: string = "";

    export { className as class };
    export let manager: CollapsibleControlManager;
    let collapsedStore = manager.getCollapsedStore();
</script>

<Control class="{className} {$collapsedStore ? 'collapsed' : ''}">
    {#if !$collapsedStore}
        <slot name="content" />
    {:else}
        <slot name="content-collapsed" />
    {/if}
</Control>
